import StyledCard from './StyledCard';

export default StyledCard;